import React from 'react';
import PropTypes from 'prop-types';

import { Heading } from '../../Elements/Elements';
import Chart from './Chart';

import classes from './StackedDevice.module.scss';

const StackedDevice = ({ chartData }) => {
  const { title, data } = chartData;

  return (
    <section className={classes.box}>
      <Heading>{title}</Heading>
      <div className={classes.body}>
        <Chart chartData={data} />
      </div>
    </section>
  );
};

StackedDevice.propTypes = {
  chartData: PropTypes.shape({
    data: PropTypes.object,
    title: PropTypes.string
  })
};

export default StackedDevice;
